import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// project imports
// import useAuth from 'hooks/useAuth';
import { DASHBOARD_PATH } from 'config';
import { useSelector } from 'react-redux';

// ==============================|| GUEST GUARD ||============================== //

/**
 * Guest guard for routes having no auth required
 * @param {PropTypes.node} children children element/node
 */

const GuestGuard = ({ children }) => {
    const navigate = useNavigate();
    const account = useSelector((state) => state.account);
    const { isLoggedIn, isProfile } = account;

    useEffect(() => {
        if (isLoggedIn) {
            navigate(DASHBOARD_PATH, { replace: true });
            // if(isProfile){
            //     navigate(DASHBOARD_PATH, { replace: true });
            // } else {
            //     navigate(PROFILE_PATH, {replace: true})
            // }
        }
    }, [isLoggedIn, isProfile, navigate]);

    return children;
};

GuestGuard.propTypes = {
    children: PropTypes.node
};

export default GuestGuard;
